import React, { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import { backend, eventBackend, GroupListData } from "../../services";
import ManShortSelector from "../../components/ui/shortItemSelect";
import { AddUserGroupModalProps, AddUserModalProps, EventFullData, UserShortInfo } from "../../types";
import { currentUserGroupFilter } from "../../state/functions";

const GroupAddUserModal: React.FC<AddUserGroupModalProps> = ({
  group_id,
  onSave,
  closeModal,
}) => {
  const [pending, setPending] = useState(false);
  const [memberToAdd, setMemberToAdd] = useState(0);
  const [memberToDelete, setMemberToDelete] = useState(0);
  const [memberToOwn, setMemberToOwn] = useState(0);
  const modalRef = useRef<HTMLDivElement>(null); // Ref для модального окна
  const [existUsers, setExistUsers] = useState<UserShortInfo[]>([]);
  const [availableUsers, setAvailableUsers] = useState<UserShortInfo[]>([]);
  const [groups, setGroups] = useState<GroupListData[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<number>(-1); 

  useEffect(() => {
    backend.getAllUsersShorts(currentUserGroupFilter()).then((res) => {
      setExistUsers(res.users)
   }).catch((err) => {
      console.log(err);
      toast("Не удалось загрузить список пользователей");
   });
   backend.getGroupsList().then((res) => {
     setGroups(res.groups)
   }).catch((e) => {
    toast("Не удалось загрузить список групп")
   });
  }, [])

  useEffect(() => {
     backend.getAllUsersShorts({group_id: selectedGroup}).then((res) => {
        setAvailableUsers(res.users)
     }).catch((err) => {
        console.log(err);
        toast("Не удалось загрузить список пользователей");
     });
  }, [selectedGroup])

  // Обработчик клика за пределами модального окна
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        closeModal(); // Закрываем модальное окно
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeModal]);


  const saveAction = () => {
     if (pending) return;
     if (!group_id) return;
     setPending(true);
     Promise.all([
      memberToDelete > 0 ? backend.deleteUserFromGroup({
        user_id: memberToDelete,
        group_id: group_id,
        group_role_id: 2
      }) : async () => 1,
      memberToAdd > 0 ? backend.addUserToGroup({
        user_id: memberToAdd,
        group_id: group_id,
        group_role_id: 2
      }) : async () => 1,
      memberToOwn > 0 ? backend.addUserToGroup({
        user_id: memberToOwn,
        group_id: group_id,
        group_role_id: 1
      }) : async () => 1,
     ]).then(() => {
      onSave();
      toast("Данные сохранены");
      closeModal();
     }).catch(() => {
      toast("Оштбка сохранения данных")
     }).finally(() => {
      setPending(false)
     })
  }

  return (
    <div className="editModal" ref={modalRef}>
      <div className="modalHeading">
        <h3>Редактировать участников группы</h3>
      </div>
      <div className="columnCenter creationForm">
        <div className="formField flex formRow">
          <label htmlFor="user">Удалить участника</label>
          <ManShortSelector
            items={existUsers}
            onChangeCallback={(id) => setMemberToDelete(id)}
            defaultSelectedId={memberToDelete}
          />
        </div>
        <div className="formField formRow">
          <label htmlFor="title">Из группы:</label>
          <select
              id="group_id"
              name="group_id"
              value={selectedGroup}
              onChange={(event) =>
                setSelectedGroup(Number(event.target.value))
              }
            >
              <option value={-1}>Не состоящие в группе</option>
              {groups.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
        </div>
        <div className="formField flex formRow">
          <label htmlFor="user">Добавить участника</label>
          <ManShortSelector
            items={availableUsers}
            onChangeCallback={(id) => setMemberToAdd(id)}
            defaultSelectedId={memberToAdd}
          />
        </div>
        <div className="formField flex formRow">
          <label htmlFor="user">Владелец</label>
          <ManShortSelector
            items={existUsers}
            onChangeCallback={(id) => setMemberToOwn(id)}
            defaultSelectedId={memberToOwn}
          />
        </div>
      </div>
      <div className="flex between btnRow">
      <button className="filterButton" type="button" onClick={saveAction}>
          Сохранить
        </button>
        <button className="cancelButton" type="button" onClick={closeModal}>
          Отменить
        </button>
      </div>
    </div>
  );
};

export default GroupAddUserModal;